import {inheritPrototype, isDef} from '../util/util'
import echarts from 'echarts'
import Base from './base'


// 折线图和柱状图 混合
var PolarShare = function (dataList, type) {
    Base.call(this)
    this.type = type
    if (dataList) {
        this.xList = isDef(dataList.xList) ? dataList.xList : []
        this.yList = isDef(dataList.yList) ? dataList.yList : []
        this.optionSet = isDef(dataList.optionSet) ? dataList.optionSet : {}
    } else {
        this.xList = []
        this.yList = []
        this.optionSet = {}
    }

    this.init()
}
inheritPrototype(PolarShare, Base)
PolarShare.prototype.init = function () {
    this.option.toolbox = this.getToolbox()
    this.option.grid = this.getGrid()
    //this.option.tooltip = this.getTooltip()
    this.option.angleAxis = this.getAngleAxis();
    this.option.radiusAxis = this.getRadiusAxis();
    this.option.polar = {};
    this.option.series = this.getSeries()
}
PolarShare.prototype.getAngleAxis = function () {
    return {
        type: 'category',
        data: this.xList,
        axisLine: {
            show: false,
            lineStyle: {
                color: '#fff'
            }
        },
        axisLabel: {
            interval: 0,
            show: true,
            color: "#fff",
            margin:5,
            fontSize: 14/*,
            formatter: function (value, index) {
            }*/
        },

        z: 10
    }
}
PolarShare.prototype.getRadiusAxis = function () {
    return {
        splitNumber:5,
        splitLine: {
            show: true,
            lineStyle: {
                color: 'gray',
                opacity: 0.6
            }
        },
        axisLine: {
            show: true,
            lineStyle: {
                color: 'gray',
                opacity: 0.6
            }

        },
        axisLabel: {
            show: false

        },
        axisTick: {
            show: false
        }
    }
}

PolarShare.prototype.getSeries = function () {
    let series = []
    if (this.yList) {
        for (let item of this.yList) {
            let d = {};
            if (item.type == 'line') {
                d = {
                    type: 'line',
                    data: item.data,
                    coordinateSystem: 'polar',
                    lineStyle: {
                        normal: {
                            color: '#81BBF1',
                            opacity: 0,
                        },
                    },
                    label: {
                        normal: {
                            show: true,
                            position:'inside',
                            padding:[10,20,30,30],
                            // size: 12,
                            fontSize: 12,
                            color: '#fff',
                            fontWeight: 'bolder',
                            formatter: function (p) {
                                return p.data + "%";
                            }
                        }
                    }
                }
            } else {
                d = {
                    type: 'bar',
                    data: item.data,
                    coordinateSystem: 'polar',
                    itemStyle: {
                        normal: {
                            color: isDef(item.color) && item.color.length > 0
                                ? new echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [
                                        {offset: 0, color: item.color[0]},
                                        {offset: 1, color: item.color[1]}
                                    ])
                                : ''
                        }
                    }
                }
            }
            series.push(d);
        }
    }
    return series;
}

export default PolarShare
